import styled from 'styled-components'

import { BottomSheet as BottomSheetUI } from '@interco/inter-ui/components/BottomSheet'
import { Button as ButtonUI } from '@interco/inter-ui/components/Button'
import { Text as TextUI } from '@interco/inter-ui/components/Text'
import * as GlobalStyles from '@/styles/styles'

export const BottomSheet = styled(BottomSheetUI)``

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 0 0;
  justify-content: center;
  align-items: center;
`

export const Text = styled(TextUI)``

export const Space = styled(GlobalStyles.DefaultSpace)``

export const Button = styled(ButtonUI)`
  width: 100%;
`
